import React, { FC } from 'react';
import styled from 'styled-components/native';
import Colors from 'theme/colors';
import Fonts from 'theme/fonts';
import { getPartMeta } from 'config/toeicMeta';

interface Props {
  partNumber?: number | string;
}

const Wrap = styled.View`
  background-color: ${Colors.SURFACE};
  border-left-width: 3px;
  border-left-color: ${Colors.MAIN_COLOR};
  border-radius: 8px;
  padding: 12px 14px;
  margin: 0 8px 14px;
`;

const Label = styled(Fonts.Bold)`
  font-size: 13px;
  color: ${Colors.MAIN_COLOR};
  margin-bottom: 4px;
`;

const Tip = styled(Fonts.Normal)`
  font-size: 14px;
  color: ${Colors.TEXT};
  line-height: 20px;
`;

const TipMuted = styled(Fonts.Normal)`
  font-size: 13px;
  color: ${Colors.MUTED_TEXT};
  line-height: 18px;
  margin-top: 6px;
`;

const PracticeTip: FC<Props> = ({ partNumber }) => {
  const meta = getPartMeta(partNumber);
  if (!meta) return null;
  return (
    <Wrap>
      <Label>{`Mẹo Part ${meta.part} · ${meta.vi}`}</Label>
      <Tip>{meta.tip}</Tip>
      <TipMuted>
        Chọn đáp án → kéo xuống cuối → bấm Nộp bài để xem điểm và lời giải.
      </TipMuted>
    </Wrap>
  );
};

export default PracticeTip;
